module.exports = __webpack_public_path__ + "static/media/address_icon_active.95f253e3.svg";